import React from 'react';
import styled from 'styled-components';
import { getEnergyEfficiencyGrade, Product, WishlistHelper } from '@packages/common';
import { themeGet } from '@packages/ui';
import { useABTestingConfig } from '@packages/shared';

import { WishListButton, SaleAndNewProductFlag, PromotionFlags } from './widgets';
import { MagnifyingGlassButton } from './widgets/MagnifyingGlassButton';

const Wrapper = styled.div`
  position: absolute;
  top: 0;

  width: 100%;
  height: 100%;

  padding-top: ${themeGet.space(1)};
`;

export interface ProductTileWidgetsProps {
  product: Product;
  wishlistHelper: WishlistHelper;
  className?: string;
  hidePromotionsOnXS: boolean;
  sorted: boolean;
  index: number;
}

export const ProductTileWidgets: React.FC<ProductTileWidgetsProps> = ({
  product,
  wishlistHelper,
  className,
  hidePromotionsOnXS,
  sorted,
  index,
}) => {
  const { voucher, flags } = product;
  const { SHOW_MAGNIFYING_GLASS } = useABTestingConfig();
  return (
    <Wrapper className={className}>
      <WishListButton wishlistHelper={wishlistHelper} product={product} />
      {SHOW_MAGNIFYING_GLASS && (
        <MagnifyingGlassButton product={product} sorted={sorted} index={index}></MagnifyingGlassButton>
      )}
      <PromotionFlags
        hidePromotionsOnXS={hidePromotionsOnXS}
        voucher={voucher}
        flags={flags}
        energyEfficency={getEnergyEfficiencyGrade(product)}
      ></PromotionFlags>
      <SaleAndNewProductFlag
        features={product.features}
        price={product.price}
        createdAt={product.createdAt}
      ></SaleAndNewProductFlag>
    </Wrapper>
  );
};

ProductTileWidgets.displayName = 'ProductTileWidgets';
